// These are the fields in an "item" in the database.
// Name is a name to show when editing in the UI
// Key is the key in a map for this field
// Type is the type of the item (used by EditObject to do the right thing for this field)
//    "button"
//    "checkbox"
//    "color"
//    "date"
//    "datetime-local"
//    "email"
//    "file"
//    "hidden"
//    "image"
//    "month"
//    "number"
//    "password"
//    "radio"
//    "range"
//    "reset"
//    "search"
//    "select"   (needs a `selects` array of {id, index, name}; EditForm
//               stores the id and displays the name)
//    "submit"
//    "tel"
//    "text"
//    "time"
//    "url"
//    "week"

import { itemTypeSelects } from './ItemTypes.mjs';
import { trackingSelects } from './ItemTracking.mjs';
import { defaultSoonDays, defaultSoonCounter } from './TaskBuckets.mjs';

export const itemFields = [
  {name: "Name",              key: "name",          type: "text"},
  // Second, so it is the next thing asked after the name -- but never FIRST:
  // EquipmentInfoUI does itemFields.slice(1) on the assumption that index 0 is
  // `name`, and ModalEditForm focuses the first field on open.
  //
  // `selects` is static (unlike the counter pickers, which are injected per
  // render by buildFieldsForItem), so it is declared here rather than mutated
  // onto the array at call time.
  {name: "Type",              key: "itemType",      type: "select", selects: itemTypeSelects()},
  // Full tracking vs trips & logs only (ItemTracking.mjs). A select row here
  // is the whole toggle: editable in every item edit modal, persisted by
  // saveEditedItem's copyOnlyKnownFields, displayed by EquipmentInfoUI's
  // generic select branch, and clearable back to Full tracking -- which is
  // the upgrade path for a log-only boat, no migration involved.
  {name: "Tracking",          key: "tracking",      type: "select", selects: trackingSelects()},
  {name: "Manufacturer",      key: "manufacturer",  type: "text"},
  {name: "Description",       key: "description",   type: "text"},
  {name: "Serial Number",     key: "serialNumber",  type: "text"},
  {name: "Part Number",       key: "partNumber",    type: "text"},
  {name: "Location",          key: "location",      type: "text"},
  {name: "Notes",             key: "notes",         type: "text"},
  {name: "Date Installed",    key: "dateInstalled", type: "date"},
  {name: "Counter Installed", key: "counterInstalled",type: "number"},
  // The item's own "due soon" window (TaskBuckets.soonThresholds is the one
  // reader). Blank saves as null and means the default, which the placeholder
  // shows. `min` only sets the spinner floor -- validateItem is what rejects a
  // typed 0, which soonThresholds would otherwise quietly read as "unset".
  {name: "Due Soon (days)",    key: "soonDays",    type: "number", min: 1, step: 1, placeholder: String(defaultSoonDays)},
  {name: "Due Soon (counter)", key: "soonCounter", type: "number", min: 0, step: 1, placeholder: String(defaultSoonCounter)},
  // "itemhoursId",
  // "pictures",
];


